// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__6qFfO","loader":"Loading_loader__1JRsT","spin":"Loading_spin__3EvV0"};